import { ThemeContext } from '@/context/theme-context';
import { setLocalStorage } from '@/local-storage/utils';
import { Moon, Sun } from 'lucide-react';
import { useContext } from 'react';

export const LandingThemeSelector = () => {
  const { theme, setTheme } = useContext(ThemeContext);
  return (
    <div
      onClick={() => {
        const newTheme = theme === 'light' ? 'dark' : 'light';

        document.body.classList.remove('light', 'dark');
        document.body.classList.add(newTheme);

        setTheme(newTheme);
        setLocalStorage('theme', newTheme);
      }}
      className="h-5 w-5 cursor-pointer"
    >
      {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </div>
  );
};
